import React from 'react';
import styled from 'styled-components';

import {
  FeatureListItem,
  FeatureListItemBullet,
  FeatureListItemText,
} from 'src/commons/components/FeatureListItem';
import Heading from 'src/commons/components/Heading';
import {
  MOBILE_BREAKPOINT,
  SMALL_MOBILE_BREAKPOINT,
  TABLET_BREAKPOINT,
} from 'src/commons/constants';
import { useAnnualFee } from 'src/commons/utilities/useAnnualFee';

import { AutoPayExpirationIcon } from './AutoPayIcon';

const SecondAttemptHeading = styled(Heading)`
  max-width: 22.5rem;
  line-height: 2rem;
  @media (max-width: ${SMALL_MOBILE_BREAKPOINT}) {
    max-width: 18.75rem;
  }
`;
SecondAttemptHeading.displayName = 'AutoPaySecondAttemptHeading';

const FeatureList = styled.div`
  max-width: 22.5rem;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  margin: 1.5625rem 0;
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    max-width: 18.75rem;
  }
`;
FeatureList.displayName = 'AutoPayFeatureList';

const SecondAttemptFeatureListItemText = styled(FeatureListItemText)`
  font-size: 1rem;
  line-height: 1.5rem;
`;
SecondAttemptFeatureListItemText.displayName =
  'AutoPaySecondAttemptFeatureListItemText';

const SecondAttemptFeatureListItemBullet = styled(FeatureListItemBullet)`
  margin: 0.25rem 0.75rem 0 0;
  align-self: baseline;
  @media (max-width: ${TABLET_BREAKPOINT}) {
    margin: 0.25rem 0.625rem 0 0;
  }
`;
SecondAttemptFeatureListItemBullet.displayName =
  'AutoPaySecondAttemptFeatureListItemBullet';

const SecondAttemptFeatureListItem = styled(FeatureListItem)`
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    padding: 0.375rem 0;
  }
`;
SecondAttemptFeatureListItem.displayName =
  'AutoPaySecondAttemptFeatureListItem';

export const AutoPaySecondAttemptContent = () => {
  const annualFee = useAnnualFee();

  return (
    <>
      <AutoPayExpirationIcon />
      <SecondAttemptHeading>
        {`Don’t miss out — the offer to save $${annualFee} expires after 25 days`}
      </SecondAttemptHeading>
      <FeatureList>
        <SecondAttemptFeatureListItem>
          <SecondAttemptFeatureListItemBullet />
          <SecondAttemptFeatureListItemText>
            Enroll in AutoPay now and skip the first year’s annual fee²
          </SecondAttemptFeatureListItemText>
        </SecondAttemptFeatureListItem>
        <SecondAttemptFeatureListItem>
          <SecondAttemptFeatureListItemBullet />
          <SecondAttemptFeatureListItemText>
            AutoPay helps ensure you don’t miss a payment
          </SecondAttemptFeatureListItemText>
        </SecondAttemptFeatureListItem>
        <SecondAttemptFeatureListItem>
          <SecondAttemptFeatureListItemBullet />
          <SecondAttemptFeatureListItemText>
            Choose the amount and date you pay each month
          </SecondAttemptFeatureListItemText>
        </SecondAttemptFeatureListItem>
      </FeatureList>
    </>
  );
};
